var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{attrs:{"id":"app"}},[(_vm.is_stenmark)?_c('Stenmark'):_vm._e(),(_vm.is_default)?_c('Default',{attrs:{"lang":_vm.lang,"tag":_vm.tag}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }